export default __webpack_public_path__ + "static/media/international_delivery.609222ea.png";